export default __webpack_public_path__ + "static/media/fluent-emoji-flat_3rd-place-medal.a457a059.svg";